$(document).ready(function() {
  
     // Função para reconstruir as imagens
    function construirImagens() {
        var $carouselList = $('body.product .product__media-wrapper .carousel-product-medias ul:not(.slick-dots)');
    
        // Verifica se o slick está inicializado antes de chamar unslick
        if ($carouselList.hasClass('slick-initialized')) {
            $carouselList.slick('unslick');  // Remove a instância do slick
        }
    
        // Limpa o bloco de imagens antes de reconstruir
        $carouselList.empty();
    
        if ($('.product__media-wrapper .product__media-list .product__media-item .product__media img').length > 0) {
            $('.product__media-wrapper .product__media-list .product__media-item .product__media img').each(function () {
                var imgProduct = $(this).clone();
                var imgSrc = $(this).attr('src');  // Pegando o src da imagem
                var imgWidth = $(this)[0].naturalWidth; // Largura original da imagem
                var imgHeight = $(this)[0].naturalHeight; // Altura original da imagem
    
                // Estilo de background e tamanho da li
                var liImgProduct = `<li class="image-product" style="background-image: url('${imgSrc}'); width: ${imgWidth}px; height: ${imgHeight}px;">
                                        <img src="${imgSrc}" alt="" style="transition: opacity 0.3s;"> 
                                      </li>`;
    
                $(liImgProduct).appendTo($carouselList);
            });
        }
    
        // Reaplica o efeito de zoom nas imagens
        $carouselList.find('li').mousemove(function(e) {
            var zoomer = e.currentTarget;
            var offsetX = e.offsetX || e.touches[0].pageX;
            var offsetY = e.offsetY || e.touches[0].pageY;
    
            var x = offsetX / zoomer.offsetWidth * 100;
            var y = offsetY / zoomer.offsetHeight * 100;
            zoomer.style.backgroundPosition = `${x}% ${y}%`;
        });
    
        // Alternar entre mostrar e esconder a imagem ao clicar
        $carouselList.find('li img').on('click', function() {
            var parentLi = $(this).parent();
    
            parentLi.toggleClass('zoom');
            if (parentLi.hasClass('zoom')) {
                $(this).css('opacity', '0'); // Esconde a imagem
            } else {
                $(this).css('opacity', '1'); // Mostra a imagem novamente
            }
        });
    
        // Verifica a quantidade de imagens e ativa os dots apenas quando maior que 1
        if ($carouselList.find('li').length > 1) {
            $carouselList.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true // Ativa os dots
            });
        }
    }
    
    // Inicializa as imagens quando a página carregar
    construirImagens();
    
    // Adiciona o evento de mudança na seleção de cor
    $(document).delegate('.product .product__info-container input[name^="Cor-"], .product .product__info-container input[name^="Color-"]','click', function() {
       setTimeout(function(){
          construirImagens();
       }, 800);
    });


    //Botão de adicionar ao carrinho fake
    $(document).delegate('body.product .product__info-container .btns-fake-product .btn-buy-fake:not(.button--disabled)', 'click', function(){
        $(this).parent().addClass('load');
    
        var variantID = $('body.product .product__info-container .product-variant-id').val();
        
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: variantID,
                    quantity: 1
                }]
            })
        }).then(response => {
            //alert('Produto adicionado ao carrinho!');
            const event = new Event('product:added');
            document.dispatchEvent(event);
            $(this).parent().removeClass('load');
        }).catch(error => {
            console.error('Erro ao adicionar ao carrinho:', error);
            $(this).parent().removeClass('load');
        });
    });

    // Máscara para o campo de CEP
    document.getElementById('cep').addEventListener('input', function(event) {
        var cep = event.target.value.replace(/\D/g, ''); // Remove qualquer caractere não numérico
        if (cep.length <= 5) {
            event.target.value = cep; // Até 5 caracteres, só mostra os números
        } else {
            event.target.value = cep.substring(0, 5) + '-' + cep.substring(5, 8); // Aplica a máscara
        }
    });

    /*
    // Função para calcular o frete
    function calcularFrete() {
        var cep = document.getElementById('cep').value.replace(/\D/g, ''); // Remove qualquer caractere não numérico
        if (cep.length === 8) {
            // Faz a requisição para calcular o frete
            fetch(`/cart/shipping_rates.json?shipping_address[zip]=${cep}`)
                .then(response => response.json())
                .then(data => {
                    if (data.shipping_rates && data.shipping_rates.length > 0) {
                        var resultado = '<ul>';
                        resultado += `<li class="title-result"><span>Prazo</span> <span></span> <span>Valor</span></li>`;
                        data.shipping_rates.forEach(rate => {
                           // Verifica se existe o prazo de entrega (assumindo que o campo seja delivery_date ou similar)
                            var prazoEntrega = rate.delivery_date ? `Em até ${rate.delivery_date} dias úteis` : 'Prazo de entrega não disponível';
                            
                            // Exibe o nome, preço e prazo de entrega (se disponível)
                            resultado += `<li><span class="shipping-name">${rate.name}</span>  <span class="shipping-estimate"> ${prazoEntrega}</span> <span class="shipping-price">${rate.price}</li>`;
                    
                        });
                        resultado += '</ul>';
                        document.getElementById('resultado-frete').innerHTML = resultado;
                    } else {
                        document.getElementById('resultado-frete').innerHTML = '<span class="not-possible">Não foi possível calcular o frete.</span>';
                    }
                })
                .catch(error => {
                    document.getElementById('resultado-frete').innerHTML = '<span class="error-cep">Erro ao calcular o frete.</span>';
                });
        } else {
            document.getElementById('resultado-frete').innerHTML = '<span class="cep-invalid">Por favor, insira um CEP válido.</span>';
        }
    }
    
    // Aciona o cálculo do frete ao clicar no botão
    document.getElementById('calcular-frete').addEventListener('click', calcularFrete);
    
    // Aciona o cálculo do frete ao pressionar a tecla "Enter"
    document.getElementById('cep').addEventListener('keypress', function(event) {
        if (event.key === 'Enter') {
            calcularFrete();
        }
    });

    */

    // Função para aplicar o slick na vitrine de produtos relacionados

    setTimeout(function() {
      applySlickToVitrine(); 
    }, 800);
    function applySlickToVitrine() {
        const vitrine = document.querySelector('.related-products .product-grid');
        if (vitrine && !vitrine.classList.contains('slick-initialized')) {
            $(vitrine).slick({
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true,
                dots: true,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 300,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
            console.log('Slick aplicado');
        }
    }


});
